<script setup lang="ts">
import LayoutDefault from "./LayoutDefault.vue";
import { markRaw, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import TokenService from "@/services/tokenService";
import { useUserStore } from "@/stores/user";

const layout = ref();
const route = useRoute();


const authStore = useAuthStore();
const router = useRouter();
const userStore = useUserStore();

onMounted(async () => {
  const urlParams = new URLSearchParams(window.location.search);
  const authCallback = urlParams.get('auth-callback');

  if (authCallback) {
    const decodedQueryString = atob(authCallback);
    const queryParams = new URLSearchParams(decodedQueryString);

    const idToken = queryParams.get('idToken');
    const accessToken = queryParams.get('accessToken');
    const refreshToken = queryParams.get('refreshToken');


    if (idToken && accessToken && refreshToken) {
      localStorage.setItem('idToken', idToken);
      localStorage.setItem('token', accessToken);
      localStorage.setItem('refreshToken', refreshToken);

      authStore.$patch({isLoggedIn: accessToken})

      const redirectPath = localStorage.getItem('redirectPath');
      localStorage.removeItem('redirectPath');
      
      const excludedPaths = ['/login', '/sign-out', 'logout', '/auth'];
      const shouldRedirectToDashboard = !redirectPath || 
        excludedPaths.some(path => redirectPath.startsWith(path));
      
      if (shouldRedirectToDashboard) {
        router.replace({ query: {} });
      } else {
        router.replace({ path: redirectPath, query: {} });
      }
    }

  }
})


watch(
  () => route?.meta.layout as string | undefined,
  async (metaLayout) => {
    try {
      const component =
        metaLayout && (await import(`./Layout${metaLayout}.vue`));
      layout.value = markRaw(component?.default || LayoutDefault);
    } catch (e) {
      layout.value = markRaw(LayoutDefault);
    }
  },
  { immediate: true }
);
</script>
<template>
  <component :is="layout"><router-view /></component>
</template>
